import { connect } from 'react-redux';
import { patchAccount } from 'state/callers/account';
import { myAccountSelector } from 'state/selectors/account';
import UserProfile from './UserProfile';

const mapStateToProps = state => {
  const { organization } = state;
  return {
    organization,
    account: myAccountSelector(state)
  };
};

const mapDispatchToProps = {
  patchAccount
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
